import { render } from "./editItemForm.vue?vue&type=template&id=ebde6896&scoped=true"
import script from "./editItemForm.vue?vue&type=script&lang=js"
export * from "./editItemForm.vue?vue&type=script&lang=js"

import "./editItemForm.vue?vue&type=style&index=0&id=ebde6896&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebde6896"]])

export default __exports__